<template>
  <div class="inner-container document-categories-page" :class="{ 'min-container': !getTabs }">
    <div class="page-header d-flex flex-wrap align-items-center justify-content-between mb-3">
      <h1>{{  "Catégories de Documents" }}</h1>
      <b-button variant="primary" @click="openCreateModal">
        <font-awesome-icon icon="plus" class="mr-1" />
        {{  "Ajouter catégorie" }}
      </b-button>
    </div>

    <div class="content">
      <!-- Filtres -->
      <div class="d-flex align-items-center mb-3" style="gap: 1rem;">
        <b-form-input
          v-model="search"
          :placeholder="$t('SEARCH') || 'Rechercher...'"
          size="sm"
          style="max-width: 250px;"
          @input="onSearchInput"
        />
      </div>

      <!-- Tableau -->
      <div class="table-responsive">
        <table class="table table-hover table-striped">
          <thead class="thead-dark">
            <tr>
              
              <th>{{ "Libellé" }}</th>
              <th>{{ $t("CREATED_AT") || "Créé le" }}</th>
              <th>{{  "Actions" }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="getDocumentCategoriesLoading && !getDocumentCategories.length">
              <td colspan="5" class="text-center py-4">
                <b-spinner small />
                
              </td>
            </tr>
            <tr v-else-if="!getDocumentCategories.length">
              <td colspan="5" class="text-center text-muted py-4">
                {{ $t("NO_CATEGORIES") || "Aucune catégorie trouvée." }}
              </td>
            </tr>
            <tr v-for="item in getDocumentCategories" :key="item.id">
            
              <td>{{ item.label === 'CEE' ? 'CC' : (item.label || '-') }}</td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td>
                <!-- Actions pour Devis et Facture seulement -->
                <template v-if="item.label !== 'CEE' && item.label !== 'AH' && item.label !== 'Devis' && item.label !== 'Facture' && item.label !== 'Autre'">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="mr-1"
                    :title="$t('EDIT') || 'Modifier'"
                    @click="openEditModal(item)"
                  >
                    <font-awesome-icon icon="edit" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    :title="$t('DELETE') || 'Supprimer'"
                    @click="confirmDelete(item)"
                  >
                    <font-awesome-icon icon="trash" />
                  </b-button>
                </template>
                <!-- Pas d'actions pour CEE et CC -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="totalPages > 1" class="d-flex justify-content-center mt-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="getDocumentCategoriesTotal"
          :per-page="perPage"
          @change="onPageChange"
        />
      </div>
    </div>

    <!-- Modal Créer/Modifier -->
    <b-modal
      id="categoryModal"
      ref="categoryModal"
      :title="isEditing ? ( 'Modifier la catégorie') : ( 'Ajouter une catégorie')"
      hide-footer
      @hidden="resetModal"
    >
      <b-form @submit.prevent="submitForm">
        <b-form-group :label=" 'Libellé'" label-for="category-label">
          <b-form-input
            id="category-label"
            v-model="form.label"
            :placeholder="'Entrez le libellé'"
            required
          />
        </b-form-group>
    
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="$refs.categoryModal.hide()">
            {{ $t("CANCEL") || "Annuler" }}
          </b-button>
          <b-button variant="primary" class="text-white" type="submit" :disabled="saving">
            <b-spinner v-if="saving" small class="mr-1" />
            {{ isEditing ? ( 'Modifier') : ( 'Créer') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DocumentCategories",
  data() {
    return {
      search: "",
      currentPage: 1,
      perPage: 10,
      searchTimeout: null,
      form: {
        id: null,
        label: "",
       
      },
      isEditing: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters(["getTabs", "getOnlineUser", "getDocumentCategories", "getDocumentCategoriesLoading", "getDocumentCategoriesTotal"]),
    totalPages() {
      return Math.ceil(this.getDocumentCategoriesTotal / this.perPage);
    },
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    ...mapActions(["fetchDocumentCategories", "createDocumentCategory", "updateDocumentCategory", "deleteDocumentCategory"]),
    async loadCategories() {
      try {
        await this.fetchDocumentCategories({
          page: this.currentPage,
          per_page: this.perPage,
          search: this.search || undefined,
        });
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err), { variant: "danger", autoHideDelay: 5000 });
      }
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadCategories();
      }, 400);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadCategories();
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    openCreateModal() {
      this.isEditing = false;
      this.form = { id: null, label: "" };
      this.$refs.categoryModal && this.$refs.categoryModal.show();
    },
    openEditModal(item) {
      this.isEditing = true;
      this.form = {
        id: item.id,
        label: item.label || "",
       
      };
      this.$refs.categoryModal && this.$refs.categoryModal.show();
    },
    resetModal() {
      this.form = { id: null, label: "" };
      this.isEditing = false;
      this.saving = false;
    },
    async submitForm() {
      if (!this.form.label?.trim()) {
        this.$bvToast && this.$bvToast.toast(this.$t("LABEL_REQUIRED") || "Le libellé est requis.", { variant: "warning", autoHideDelay: 3000 });
        return;
      }
      
      this.saving = true;
      try {
        if (this.isEditing) {
          await this.updateDocumentCategory({
            id: this.form.id,
            label: this.form.label.trim(),
          });
          this.$bvToast && this.$bvToast.toast(this.$t("UPDATE_SUCCESS") || "Catégorie modifiée.", { variant: "success", autoHideDelay: 3000 });
        } else {
          await this.createDocumentCategory({
            label: this.form.label.trim(),
       
          });
          this.$bvToast && this.$bvToast.toast(this.$t("CREATE_SUCCESS") || "Catégorie créée.", { variant: "success", autoHideDelay: 3000 });
        }
        this.$refs.categoryModal && this.$refs.categoryModal.hide();
        await this.loadCategories();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err), { variant: "danger", autoHideDelay: 5000 });
      } finally {
        this.saving = false;
      }
    },
    async confirmDelete(item) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
         `Supprimer la catégorie "${item.label}" ?`,
        {
          title: "Confirmer",
          okVariant: "danger",
          okTitle: "Supprimer",
          cancelTitle: "Annuler",
        }
      );
      if (!confirmed) return;
      try {
        await this.deleteDocumentCategory(item.id);
        this.$bvToast && this.$bvToast.toast( "Catégorie supprimée.", { variant: "success", autoHideDelay: 3000 });
        await this.loadCategories();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err), { variant: "danger", autoHideDelay: 5000 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.document-categories-page {
  padding: 20px;
}

.page-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #24316d;
}

.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table {
  margin-bottom: 0;
}

.table th {
  border-top: none;
  background-color: #24316d;
  color: #fff;
}

.table td {
  vertical-align: middle;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
